import { handleActions } from 'redux-actions';
import update from 'immutability-helper';
import {
  processing,
  getClientDetailsSuccess,
  getClientDetailsFail,
  showTermsOfUse,
  showPrivacyPolicy,
  showFeedback,
  sendMail,
  sendMailSuccess,
  getSiteCopySuccess,
  clientDetailsFetching,
  getProgramsByTopicSuccess,
  getThemesSuccess,
  getClientDetails,
  getResourcesCountByTopicSuccess,
  getClientResourcesSuccess,
  showRegionSelector,
  setRegion,
  showRegionBanner,
  clearClientDetails,
  setLandingMenu,
  showHomepagePro,
} from './actions';

export const initialState = {
  processing: false,
  clientDetails: {},
  clientDetailsFetching: false,
  error: {},
  showingTermsOfUse: false,
  showingPrivacyPolicy: false,
  showingFeedback: false,
  mailSent: false,
  siteCopy: [],
  programs: {},
  themes: [],
  resourcesCountByTopic: [],
  clientResources: [],
  showRegionSelector: false,
  region: localStorage.getItem('region') || '',
  showRegionBanner: false,
  landingMenu: null,
  showHomepagePro: false,
};
const videosReducer = handleActions(
  {
    [processing](state, action) {
      return update(state, { processing: { $set: action.payload } });
    },
    [clientDetailsFetching](state, action) {
      return update(state, { clientDetailsFetching: { $set: action.payload } });
    },
    [clearClientDetails](state) {
      return update(state, { clientDetails: { $set: {} } });
    },
    [getClientDetails](state) {
      return update(state, {
        // clientDetailsFetching: { $set: true },
        clientDetails: { $set: {} },
      });
    },
    [getClientDetailsSuccess](state, action) {
      return update(state, {
        clientDetails: {
          $set: action.payload,
        },
        // clientDetailsFetching: { $set: false },
      });
    },
    [getClientDetailsFail](state, action) {
      return update(state, {
        error: { $set: action.payload },
      });
    },
    [showTermsOfUse](state, action) {
      return update(state, { showingTermsOfUse: { $set: action.payload } });
    },
    [showPrivacyPolicy](state, action) {
      return update(state, { showingPrivacyPolicy: { $set: action.payload } });
    },
    [showFeedback](state, action) {
      return update(state, { showingFeedback: { $set: action.payload } });
    },
    [sendMail](state) {
      return update(state, { mailSent: { $set: false } });
    },
    [sendMailSuccess](state) {
      return update(state, { mailSent: { $set: true } });
    },
    [getSiteCopySuccess](state, action) {
      return update(state, { siteCopy: { $set: action.payload } });
    },
    [getProgramsByTopicSuccess](state, action) {
      return update(state, { programs: { $set: action.payload } });
    },
    [getThemesSuccess](state, action) {
      return update(state, { themes: { $set: action.payload } });
    },
    [getResourcesCountByTopicSuccess](state, action) {
      return update(state, { resourcesCountByTopic: { $set: action.payload } });
    },
    [getClientResourcesSuccess](state, action) {
      return update(state, { clientResources: { $set: action.payload } });
    },
    [showRegionSelector](state, action) {
      return update(state, { showRegionSelector: { $set: action.payload } });
    },
    [setRegion](state, action) {
      localStorage.setItem('region', action.payload);
      return update(state, { region: { $set: action.payload } });
    },
    [showRegionBanner](state, action) {
      return update(state, { showRegionBanner: { $set: action.payload } });
    },
    [setLandingMenu](state, action) {
      return update(state, { landingMenu: { $set: action.payload } });
    },
    [showHomepagePro](state, action) {
      return update(state, { showHomepagePro: { $set: action.payload } });
    },
  },

  initialState,
);

export default videosReducer;
